// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flow-visualization--header .search-widget-input{flex:0 1 500px}.query-stat{padding:8px 0;white-space:nowrap}.query-stat--bold{font-weight:600;color:#b9b9c5;padding-left:8px;padding-right:16px}.query-stat--normal{color:#828294;padding:0 8px}", ""]);
// Exports
module.exports = exports;
